namespace TabAurous.OMS {
    export namespace AttributeMasterAPIService {
        export const baseUrl = '~/api/Attributes';

        export declare function Create(request: Serenity.SaveRequest<AttributeMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<AttributeMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListAttributes(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListBrands(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListCollection(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ListSuperTypes(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<AttributeMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "~/api/Attributes/Create",
            Update = "~/api/Attributes/Update",
            Delete = "~/api/Attributes/Delete",
            Retrieve = "~/api/Attributes/Retrieve",
            List = "~/api/Attributes/List",
            ListAttributes = "~/api/Attributes/ListAttributes",
            ListBrands = "~/api/Attributes/ListBrands",
            ListCollection = "~/api/Attributes/ListCollection",
            ListSuperTypes = "~/api/Attributes/ListSuperTypes"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ListAttributes', 
            'ListBrands', 
            'ListCollection', 
            'ListSuperTypes'
        ].forEach(x => {
            (<any>AttributeMasterAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
